var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.color)?_c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":_vm.addToExpand}},on),[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("mdi-shield-alert")])],1)]}}],null,false,3298996814)},[_vm._v(_vm._s(_vm.message))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }